module.exports = __webpack_public_path__ + "img/Menu-11.6ab9227d.png";